import React, { useState } from "react";
import store from "src/store";
import Button from "./button";
import CustomModal from "./custom-modal";
import EngagementForm from "./engagement-form";
import useIsLoggedIn from "src/utils/use-is-logged-in";

export default function EngagementManagerHeader(props) {
    const {userInfo } = useIsLoggedIn();
    
    const [showCreateEngagementModal, setShowCreateEngagementModal] = useState(false);

    const [orgId, setOrgId] = useState('');
    const [engId, setEngId] = useState('');
    const [maxAllowedVersion, setMaxAllowedVersion] = useState(3);
    const [allowedEmails, setAllowedEmails] = useState([]);
    const [API_KEY, setAPI_KEY] = useState('');

    const [orgIdHasError, setOrgIdHasError] = useState(false);
    const [orgIdErrorText, setOrgIdErrorText] = useState('');
    const [engIdHasError, setEngIdHasError] = useState(false);
    const [engIdErrorText, setEngIdErrorText] = useState('');
    const [maxAllowedVersionHasError, setMaxAllowedVersionHasError] = useState(false);
    const [maxAllowedVersionErrorText, setMaxAllowedVersionErrorText] = useState('');

    const resetEngagementForm = () => {
        setOrgId('');
        setEngId('');
        setMaxAllowedVersion(3);
        setAllowedEmails([]);
        setAPI_KEY('');
        setOrgIdHasError(false);
        setOrgIdErrorText('');
        setEngIdHasError(false);
        setEngIdErrorText('');
        setMaxAllowedVersionHasError(false);
        setMaxAllowedVersionErrorText('');
    }

    const openCreateNewEngagementModal = () => {
        resetEngagementForm();
        setShowCreateEngagementModal(true);
    }

    const formIsValid = () => {
        let isValid = true;

        if(!userInfo?.auth0Subscripton) {
            if (!orgId) {
                isValid = false;
                setOrgIdHasError(true);
                setOrgIdErrorText("Organization is required");
            } else {
                setOrgIdHasError(false);
                setOrgIdErrorText("");
            }
        }

        if (!engId) {
            isValid = false;
            setEngIdHasError(true);
            setEngIdErrorText("Engagement id is required");
        } else {
            setEngIdHasError(false);
            setEngIdErrorText("");
        }

        if (engId) {
            let existingEngagementWithSameId = props.engagements.filter((item) => (item.engId == engId));
            if (existingEngagementWithSameId.length) {
                isValid = false;
                setEngIdHasError(true);
                setEngIdErrorText("Engagement id already exists");
            } else {
                setEngIdHasError(false);
                setEngIdErrorText("");
            }
        }

        if (!maxAllowedVersion) {
            isValid = false;
            setMaxAllowedVersionHasError(true);
            setMaxAllowedVersionErrorText("Maximum allowed version is required");
        } else {
            setMaxAllowedVersionHasError(false);
            setMaxAllowedVersionErrorText("");
        }

        return isValid;
    }

    const createEngagement = async () => {
        if (formIsValid()) {
            let engagementData = {
                orgId: orgId,
                engId: engId,
                allowedEmails: allowedEmails,
                maxAllowedVersion: Number(maxAllowedVersion),
                API_KEY: API_KEY
            };

            await store.createEngagement(engagementData);
            store.checkAndSetEngagementManagerFilter();
            setShowCreateEngagementModal(false);
        }
    }

    return (
        <>
            <CustomModal
                size="medium"
                title="New engagement"
                showModal={showCreateEngagementModal}
                onCloseModal={() => { setShowCreateEngagementModal(false) }}
                submitBtnText={'Create engagement'}
                onSubmit={() => { createEngagement() }}
                submitBtnDisabled={false}
            >
                <EngagementForm
                    orgId={orgId}
                    engId={engId}
                    maxAllowedVersion={maxAllowedVersion}
                    allowedEmails={allowedEmails}
                    API_KEY={API_KEY}
                    setOrgId={(value) => setOrgId(value)}
                    setEngId={(value) => setEngId(value)}
                    setMaxAllowedVersion={(value) => setMaxAllowedVersion(value)}
                    setAllowedEmails={(value) => setAllowedEmails(value)}
                    setAPI_KEY={(value) => setAPI_KEY(value)}
                    orgIdHasError={orgIdHasError}
                    engIdHasError={engIdHasError}
                    engIdErrorText={engIdErrorText}
                    orgIdErrorText={orgIdErrorText}
                    maxAllowedVersionHasError={maxAllowedVersionHasError}
                    maxAllowedVersionErrorText={maxAllowedVersionErrorText}
                    idEdit={false}
                />
            </CustomModal>

            <div css={`
                display: flex;
                flex-direction: row;
                align-items: center;
            `}>
                <div css={`
                    width: 80%;
                `}>
                    <div css={`
                        font-size:24px;
                        color:#2E2E38;
                    `}>
                        Engagement manager
                    </div>
                </div>
                <div css={`
                    width: 20%;
                `}>
                    <div css={`
                    float: right
                    `}>
                        <Button variant="contained" color="secondary" onClick={() => { openCreateNewEngagementModal() }}>Create new engagement</Button>
                    </div>
                </div>
            </div>
        </>
    )
}